import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, validateURL } from '../../lib/ep';

import Input from './Input';

const UrlField = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ is_valid, setIsValid ] = useState(true);
	const [ is_valid_protocol, setIsValidProtocol ] = useState(true);
	const force_https = props?.force_https ?? false;
	const name = props?.name ?? false;
	const add_protocol = props?.add_protocol ?? true;
	const ensure_domain = props?.ensure_domain ?? false;
	const disable_autovalidation = props?.disable_autovalidation ?? false;

	if(name === false) return null;

	const validateFormat = (value) => {
		let _is_valid = true;
		let _is_valid_protocol = true;

		if(disable_autovalidation) {
			setIsValid(_is_valid);
			setIsValidProtocol(_is_valid_protocol);
	
			if(props.passed != undefined) props.passed((_is_valid && _is_valid_protocol));
			return;
		}

		if(value != '') {
			if(force_https) {
				const re_https = /^(https:\/\/)/;
				_is_valid_protocol = re_https.test(value);
			}

			/*const re = /^(http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]%@!\$&'\(\)\*\+,;=.{}]+$/;
			_is_valid = re.test(value);*/
			let value_check = value;
			(props?.skip_chars ?? []).forEach((character, index) => {
				value_check = value_check.replace(new RegExp(character, 'g'), '');
			});

			_is_valid = validateURL(value_check, true, props?.expreg_path ?? false, props?.expreg_query ?? false);
			if(ensure_domain && _is_valid) {
				const url_parts = _is_valid;
				const _domain = url_parts[3];

				if(typeof(ensure_domain) == 'object') {
					let found = false;
					ensure_domain.map((d) => {
						const domain_re = new RegExp(`${d}$`, 'gi');
						if(domain_re.test(_domain)) found = true;
					});

					if(!found) _is_valid = false;
				} else {
					const domain_re = new RegExp(`${ensure_domain}$`, 'gi');
					if(!_domain || !domain_re.test(_domain)) _is_valid = false;
				}
			}
		}

		setIsValid(_is_valid);
		setIsValidProtocol(_is_valid_protocol);

		if(props.passed != undefined) props.passed((_is_valid && _is_valid_protocol));
	};

	useEffect(()=>{
		if(props.validate_onload){
			const valor = props?.value ?? ((props.model != undefined && props.model[name] != null) ? props.model[name] : '');
			if(valor!='')validateFormat(valor);
		}
	},[])

	const change = (k, v) => {
		v = v ? v : '';
		validateFormat(v);
		if(props.change) props.change(k, v);
	};

	const force_model_errors = props?.force_model_errors ?? false;
	
	let _props = { ...props };

	if(_props.errors == undefined) _props.errors = {};
	if(!is_valid) _props.errors[name] = "Error: Enter a valid URL";
	if(!is_valid_protocol) _props.errors[name] = "Error HTTPS";
	if(is_valid && is_valid_protocol) _props.errors[name] = null;

	// to enable external error messages
	if(force_model_errors !== false) _props.errors[name] = force_model_errors;

	_props.error_msg_position_class = props?.error_msg_position_class ?? 'is_floating';

	if(_props.placeholder == undefined) {
		_props.placeholder = `${(add_protocol) ? 'https://' : ''}${(ensure_domain !== false) ? ((typeof(ensure_domain) == 'string') ? ensure_domain : ensure_domain[0]) : i18n("www.your-domain.com")}`;
		_props.autotranslate_placeholder = false;
	}

	let classes = props?._class ?? {};
	if(classes.other == undefined) {
		classes.other = 'gui_url_input';
	} else {
		classes.other += ` gui_url_input`;
	}

	return (
		<Input
			{..._props}
			_class={classes}
			_type='url'
			change={change}
		/>
	);
}

export default injectIntl(UrlField);